// src/store.js

import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

// Core reducers
import { userReducer, adminUserReducer } from '../reducers/userReducer';
import  franchiseReducer  from '../reducers/franchiseReducer';
import { productCategoryReducer } from '../reducers/productCategoryReducer';
import { supplierReducer } from '../reducers/supplierReducer';
import { productStockReducer } from '../reducers/productStockReducer';
import { componentStockReducer } from '../reducers/componentStockReducer';
import {
  returnRefundAddReducer,
  returnRefundHistoryReducer,
} from '../reducers/returnrefundReducers';
import {
  productTransferReducer,
  componentTransferReducer,
} from '../reducers/transferReducers';

// Sales reducers
import {
  saleAddReducer,
  saleUpdateReducer,
  saleDeleteReducer,
  salesListReducer,
  saleDetailReducer,
  salesImportReducer,
  customerOrdersReducer,
  invoiceGenerateReducer,
  invoiceHistoryReducer,
  pendingPaymentsReducer,
  paymentReceiptsReducer,
  recurringInvoicesReducer,
  customerProfilesReducer,
  salesDashboardReducer,
  salesByProductReducer,
  salesGrowthTrendsReducer,
  paymentMethodsReducer,
  partialPaymentsReducer,
  refundProcessingReducer,
  paymentRemindersReducer,
  returnRequestsReducer,
  refundStatusReducer,
  damagedGoodsReturnsReducer,
  customerRefundApprovalsReducer,
  supplierReturnManagementReducer,
  warrantyBasedReturnsReducer,
  returnRefundAddsaleReducer,
  createSaleWithCustomInvoiceReducer,
} from '../reducers/saleReducers';

const rootReducer = combineReducers({
  // Auth & users
  user: userReducer,
  adminUsers: adminUserReducer,

  // Master data
  franchise: franchiseReducer,
  productCategoryList: productCategoryReducer,
  supplierList: supplierReducer,
  productStockList: productStockReducer,
  componentStockList: componentStockReducer,
  returnRefundAdd: returnRefundAddReducer,
  returnRefundHistory: returnRefundHistoryReducer,
  productTransfer: productTransferReducer,
  componentTransfer: componentTransferReducer,

  // Sales
  saleAdd: saleAddReducer,
  saleUpdate: saleUpdateReducer,
  saleDelete: saleDeleteReducer,
  salesList: salesListReducer,
  saleDetail: saleDetailReducer,
  salesImport: salesImportReducer,
  customerOrders: customerOrdersReducer,
  invoiceGenerate: invoiceGenerateReducer,
  invoiceHistory: invoiceHistoryReducer,
  pendingPayments: pendingPaymentsReducer,
  paymentReceipts: paymentReceiptsReducer,
  recurringInvoices: recurringInvoicesReducer,
  customerProfilesList: customerProfilesReducer,  // matches useSelector(state => state.customerProfilesList)
  salesDashboard: salesDashboardReducer,
  salesByProduct: salesByProductReducer,
  salesGrowthTrends: salesGrowthTrendsReducer,
  paymentMethods: paymentMethodsReducer,
  partialPayments: partialPaymentsReducer,
  refundProcessing: refundProcessingReducer,
  paymentReminders: paymentRemindersReducer,
  returnRequests: returnRequestsReducer,
  refundStatus: refundStatusReducer,
  damagedGoodsReturns: damagedGoodsReturnsReducer,
  customerRefundApprovals: customerRefundApprovalsReducer,
  supplierReturnManagement: supplierReturnManagementReducer,
  warrantyBasedReturns: warrantyBasedReturnsReducer,
  returnRefundAddsale:returnRefundAddsaleReducer,
  createSaleWithCustomInvoice:createSaleWithCustomInvoiceReducer,
});

const initialState = {};
const middleware = [thunk];

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
